export const getArticlesFromEvoPayload = (data = []) => {
    return data
        .filter((item) => item.type === "article")
        .map((item) => {
        return {
            article_id: item.identifier,
            value: item.points_without_multiply,
            is_read: item.is_read,
            is_available: item.is_available,
            levels: item.levels,
        };
    });
};
//# sourceMappingURL=getArticlesFromEvoPayload.js.map